var _desc, _rect, _pattern, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Header Background") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Church-themed header background with gradient")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 800,
    height: 200,
    fill: "url(#headerGradient)"
  })), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "churchPattern",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 15,
    fill: "#9EC630",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 8,
    fill: "#9EC630",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 8,
    fill: "#9EC630",
    opacity: 0.1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 800,
    height: 200,
    fill: "url(#churchPattern)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "headerGradient",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#D4C4A0",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#C8B59B",
      stopOpacity: 0.95
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#D4C4A0",
      stopOpacity: 0.9
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBg);
export default __webpack_public_path__ + "static/media/header-bg.d63aebcebf991dbbf6ebd39effb63d63.svg";
export { ForwardRef as ReactComponent };